export const logo = require("./logo.png");
export const userProfile = require("./user-profile.png");
export const profileDownIcon = require("./profile-arrow-down-icon.svg").default;
export const whatsappIcon = require("./whatsapp-icon.svg").default;
